import { createIcon } from "@chakra-ui/react";

const ChevronRightIcon = createIcon({
  displayName: "ChevronRightIcon",
  viewBox: "0 0 24 24",
  path: <path d="M9.4 18L8 16.6l4.6-4.6L8 7.4L9.4 6l6 6Z" fill="currentColor" />,
});

export default ChevronRightIcon;
